import { useSession } from "../session";

export const useUserId = () => {
  const { data: session } = useSession({
    retryOnMount: false
  });
  return session?.userId as string;
};
